import Button from 'components/Button'
import React, { useCallback } from 'react'
import styled from 'styled-components'
import { _ } from 'utils'

const S = {
    Image: styled.img`
        max-width: 100%;
        max-height: 75vh;
        display: inherit;
        margin: auto;
        object-fit: contain;
        object-position: center;
        border-radius: 5px;
    `,
    Actions: styled.div`
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 20px;
    `
}

interface Props<T> {
    close: () => void
    image: T
    canDelete: boolean
    canSelect: boolean
    onSelect: (image: T) => void
    onDelete: (image: T) => void
    getImageUrl: (image: T) => string
}

function ImagePreviewModal<T>({
    close, image, canSelect, canDelete, onSelect, onDelete, getImageUrl
}: Props<T>) {
    const handleDeleteImage = useCallback(() => {
        close()
        onDelete(image)
    }, [close, image, onDelete])

    const handleSelectImage = useCallback(() => {
        close()
        onSelect(image)
    }, [close, image, onSelect])

    return (
        <>
            <S.Image src={getImageUrl(image)} />
            <S.Actions>
                {canDelete ? (
                    <Button variant="danger" onClick={handleDeleteImage}>
                        {_('button.delete')}
                    </Button>
                ): <div />}
                <div>
                    <Button variant="secondary" className="mr-2" onClick={close}>
                        {_('button.cancel')}
                    </Button>
                    {canSelect && (
                        <Button variant="success" onClick={handleSelectImage}>
                            {_('button.select')}
                        </Button>
                    )}
                </div>
            </S.Actions>
        </>
    )
}

export default ImagePreviewModal
